import { BaseFetch } from "../main-model"
export default class AssetModel extends BaseFetch {
  getAssetBy = (data) =>
    this.authFetch({
      url: "asset/getAssetBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAssetById = (data) =>
    this.authFetch({
      url: "asset/getAssetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAssetById = (data) =>
    this.authFetch({
      url: "asset/updateAssetById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAsset = (data) =>
    this.authFetch({
      url: "asset/insertAsset",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAssetById = (data) =>
    this.authFetch({
      url: "asset/deleteAssetById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
